import { Controller } from "@hotwired/stimulus"

// Прячет поле даты, когда выбран бессрочный ключ.
export default class extends Controller {
  static targets = ["expiresAt"]

  connect() {
    this.toggleExpiration()
  }

  toggleExpiration() {
    const mode = this.element.querySelector("input[name='expiration_mode']:checked")?.value
    const wrapper = this.expiresAtTarget

    if (mode === "never") {
      wrapper.classList.add("hidden")
      const input = wrapper.querySelector("input")
      if (input) input.value = ""
    } else {
      wrapper.classList.remove("hidden")
    }
  }
}
